import React from "react";
import { Box, IconButton, List, ListItem, ListItemIcon, ListItemText, Tooltip, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Link, useLocation } from "react-router-dom";
import { CHAT_WINDOW_PATH } from "./navConfig";

const SECONDARY_WIDTH = 260;

const SecondarySidebar = ({ primaryItem, userRolesArray, onClose, onLinkClick, isClosing = false }) => {
    const location = useLocation();
    if (!primaryItem || !primaryItem.child) return null;

    const filteredChildren = primaryItem.childFilter
        ? primaryItem.child.filter((c) => primaryItem.childFilter(c, userRolesArray))
        : primaryItem.child;

    const offWhite = "#fffefe";

    return (
        <Box
            sx={{
                width: isClosing ? 0 : SECONDARY_WIDTH,
                minWidth: isClosing ? 0 : SECONDARY_WIDTH,
                alignSelf: "stretch",
                minHeight: 0,
                backgroundColor: offWhite,
                background: offWhite,
                display: "flex",
                flexDirection: "column",
                flexShrink: 0,
                borderLeft: isClosing ? "none" : "1px solid rgba(0,0,0,0.06)",
                borderRight: isClosing ? "none" : "1px solid rgba(0,0,0,0.06)",
                opacity: isClosing ? 0 : 1,
                overflow: "hidden",
                transition: "width 250ms cubic-bezier(0.4, 0, 0.2, 1), opacity 250ms ease-out, min-width 250ms cubic-bezier(0.4, 0, 0.2, 1)",
                animation: !isClosing ? "slideIn 250ms ease-out" : "none",
                "@keyframes slideIn": {
                    from: { opacity: 0, transform: "translateX(-16px)" },
                    to: { opacity: 1, transform: "translateX(0)" },
                },
            }}
        >
            <Box
                sx={{
                    height: 64,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: 1,
                    pr: 0,
                    backgroundColor: offWhite,
                    background: offWhite,
                    borderBottom: "1px solid rgba(0,0,0,0.08)",
                }}
            >
                <Typography variant="subtitle2" fontWeight={600} color="text.primary" fontSize="0.8rem" sx={{ pl: 1.5 }}>
                    {primaryItem.name}
                </Typography>
                <Tooltip title="Collapse" placement="left" arrow>
                    <IconButton
                        size="small"
                        onClick={onClose}
                        sx={{
                            color: "text.secondary",
                            "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" },
                        }}
                    >
                        <ChevronRightIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            </Box>
            <List sx={{ py: 1, px: 1, backgroundColor: offWhite }}>
                {filteredChildren.map((child, idx) => {
                    const isExternal = child.path === CHAT_WINDOW_PATH;
                    const isActive =
                        !isExternal &&
                        (location.pathname === child.path ||
                            location.pathname.startsWith(child.path + "/"));
                    return (
                        <ListItem
                            key={child.path || idx}
                            button
                            component={isExternal ? "a" : Link}
                            {...(isExternal ? { href: child.path, target: "_blank", rel: "noopener noreferrer" } : { to: child.path })}
                            onClick={onLinkClick}
                            sx={{
                                borderRadius: 1.5,
                                py: 1.25,
                                px: 2,
                                mb: 0.25,
                                backgroundColor: isActive ? "rgba(0,0,0,0.06)" : "transparent",
                                "&:hover": {
                                    backgroundColor: isActive ? "rgba(0,0,0,0.08)" : "rgba(0,0,0,0.04)",
                                },
                                textDecoration: "none",
                                color: "text.primary",
                            }}
                        >
                        <ListItemIcon sx={{ minWidth: 36, color: "inherit" }}>
                            {child.icon}
                        </ListItemIcon>
                        <ListItemText
                            primary={child.name}
                            primaryTypographyProps={{ fontSize: "0.8125rem" }}
                        />
                    </ListItem>
                    );
                })}
            </List>
        </Box>
    );
};

export default SecondarySidebar;
export { SECONDARY_WIDTH };
